import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { SharedUiModule } from 'src/app/shared/shared-ui.module';
import { HormigonEncuestaSatisfaccionComponent } from './encuesta-satisfaccion/encuesta-satisfaccion.component';
import { HormigonSurveySuccessModalComponent } from './survey-success-modal/survey-success-modal.component';

@NgModule({
  declarations: [
    HormigonEncuestaSatisfaccionComponent,
    HormigonSurveySuccessModalComponent,
  ],
  imports: [CommonModule, FormsModule, MatDialogModule, SharedUiModule],
  exports: [
    HormigonEncuestaSatisfaccionComponent,
    HormigonSurveySuccessModalComponent,
  ],
})
export class HormigonFirmaDigitalModule {}
